import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { SectionsInformationBoxComponent } from '@twisto/api-cms'

import { Divider } from '../../article-components'
import { StrapiMedia } from '../../atoms'

import * as styles from './information-box.styles'

export const InformationBox = ({
  title,
  description,
  subtitle,
  optionalDescription,
  steps,
  src,
  performanceItems,
  cta,
  ctaSecondary,
}: SectionsInformationBoxComponent) => (
  <section css={styles.section}>
    <div css={styles.wrapper}>
      <div css={styles.preview}>
        <StrapiMedia {...src} />
        <div css={styles.text}>
          <Typography css={styles.title} fontWeight="heavy" variant="h2">
            {title}
          </Typography>
          <Typography variant="b1">{description}</Typography>
          <Typography css={styles.subtitle} fontWeight="medium" variant="h3">
            {subtitle}
          </Typography>
          <div css={styles.steps}>
            {steps?.map((step, index) => (
              <div key={step.id} css={styles.step}>
                <div css={styles.stepLabel}>
                  {index + 1} {'\u2013'}
                </div>
                <Typography>{step.text}</Typography>
              </div>
            ))}
          </div>
          <Typography>{optionalDescription}</Typography>
        </div>
      </div>

      <Divider />

      <div css={styles.content}>
        <div css={styles.performance}>
          {performanceItems?.map((item) => (
            <div key={item.id} css={styles.performanceItem}>
              <Typography css={styles.headline} fontWeight="heavy" variant="h2">
                {item.headline}
              </Typography>
              <Typography fontWeight="medium" variant="h3">
                {item.text}
              </Typography>
            </div>
          ))}
        </div>
        <div css={styles.cta}>
          {cta?.text && cta.link && (
            <TextButton href={cta.link} size="large">
              {cta.text}
            </TextButton>
          )}
          {ctaSecondary?.text && ctaSecondary.link && (
            <TextButton color="secondary" href={ctaSecondary.link} size="large">
              {ctaSecondary.text}
            </TextButton>
          )}
        </div>
      </div>
    </div>
  </section>
)
